<div class="modal-body">
    <p>{{"are_you_sure"|translate}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">{{"no"|translate}}</button>
    <button type="button" class="btn btn-primary" (click)="confirm()">{{"yes"|translate}}</button>
</div>
